import { useTranslation } from 'react-i18next';
import { AccountsFilter } from '../../Accounts';

export const AdvertisersFilter = () => {
  const { t } = useTranslation();

  return <AccountsFilter keywordPlaceholder={t<string>('Search.AdvertiserFilterPlaceholder')} domain="advertiser" />;
};
